var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { Box, DateInput } from '@pocketlaw/tetris';
import { useField, useFormikContext } from 'formik';
import { ErrorMessage } from '../ErrorMessage';
export function DateField(props) {
    const { name } = props, rest = __rest(props, ["name"]);
    const { isSubmitting } = useFormikContext();
    const [field, meta, helpers] = useField(name);
    const error = Boolean(meta.touched && meta.error);
    const value = useMemo(() => {
        if (field.value) {
            return new Date(field.value);
        }
        return undefined;
    }, [field.value]);
    const handleChange = (date) => {
        helpers.setValue(date.toISOString());
    };
    return (<Box flexDirection="column" gap="sm">
      <DateInput {...rest} value={value} disabled={isSubmitting} invalid={error} onChange={handleChange}/>
      <ErrorMessage name={name}/>
    </Box>);
}
